import { render } from "./RegisterConfirm.vue?vue&type=template&id=2909a97d"
import script from "./RegisterConfirm.vue?vue&type=script&lang=js"
export * from "./RegisterConfirm.vue?vue&type=script&lang=js"
script.render = render

export default script